import React from 'react'
import { Box, Text } from '@fundamentals'
import { Comment } from '@core/entities/comments'
import { AttachmentInput } from '@elements/Questions/AttachmentInput'
import { alpha } from '@mui/system'
import { useTheme } from '@mui/material'

type CommentProps = {
  comment: Comment
  showInfo?: boolean
}

const CommentItem: React.FC<CommentProps> = ({ comment, showInfo = true }) => {
  const theme: any = useTheme()

  return (
    <>
      <Box
        sx={{
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
          mt: 2,
          p: 2,
          borderRadius: 1,
          position: 'relative',
          border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
        }}
      >
        {comment?.message && (
          <Text
            variant='body2'
            color='grey.800'
            mb={comment.mediaUrlsWithType?.length > 0 ? 2 : 0}
          >
            {comment.message}
          </Text>
        )}
        <AttachmentInput
          inputProps={{
            value: comment.mediaUrlsWithType,
          }}
          readOnly
          borderLess
          size='small'
          mt={-1}
        />
      </Box>
      {showInfo && (
        <Text
          variant='body2'
          align='right'
          color='grey.600'
          fontSize={12}
          sx={{ mt: 1 }}
        >
          {comment?.getInfo()}
        </Text>
      )}
    </>
  )
}

export default CommentItem
